import { Button, Typography } from 'antd';
import { FileTextOutlined, GlobalOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface Props {
  onAddDocument: () => void;
  onAddSite: () => void;
}

/**
 * Состояние «ничего не выбрано» — показывается изначально и после
 * закрытия других режимов (например, после удаления источника).
 *
 * Это центральный визуальный hook: показывает юзеру что можно
 * сделать на этой вкладке. Две большие кнопки — добавить документ
 * и подключить сайт.
 */
export function WelcomeState({ onAddDocument, onAddSite }: Props) {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <Title level={4} style={{ marginBottom: 8 }}>
          База знаний ассистента
        </Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
          Загрузите документы или подключите сайт, чтобы ассистент использовал
          эту информацию при ответах. Выберите источник слева для просмотра деталей.
        </Text>

        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            size="large"
            icon={<FileTextOutlined />}
            onClick={onAddDocument}
            style={{ minWidth: 200 }}
          >
            Добавить документ
          </Button>
          <Button
            size="large"
            type="primary"
            icon={<GlobalOutlined />}
            onClick={onAddSite}
            style={{ minWidth: 200 }}
          >
            Подключить сайт
          </Button>
        </div>
      </div>
    </div>
  );
}
